module.exports = __webpack_public_path__ + "img/avatar.dbc34c19.jpg";